module.exports = __webpack_public_path__ + "2d55f8b3f.jpg";